module.exports = __webpack_public_path__ + "img/stars.8c341b29.svg";